import { render, staticRenderFns } from "./DocsHeader.vue?vue&type=template&id=e4361d48&"
import script from "./DocsHeader.vue?vue&type=script&lang=js&"
export * from "./DocsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports